// extracted by mini-css-extract-plugin
export default {"empty":"Placeholder_empty__wtf-1","large":"Placeholder_large__7ZTQf"};